export interface CategoryFilters {
  media: string;
  year: string;
  minRating: string;
}

interface FilterSidebarProps {
  years: number[];
  filters: CategoryFilters;
  onChange: (next: Partial<CategoryFilters>) => void;
  onReset: () => void;
}

const MEDIA_OPTIONS = [
  { value: "all", label: "全部" },
  { value: "电影", label: "电影" },
  { value: "电视剧", label: "电视剧" },
];

const RATING_OPTIONS = [
  { value: "all", label: "全部" },
  { value: "8.5", label: "8.5 分以上" },
  { value: "8.0", label: "8.0 分以上" },
  { value: "7.5", label: "7.5 分以上" },
];

function Group({
  title,
  options,
  active,
  onPick,
}: {
  title: string;
  options: { value: string; label: string }[];
  active: string;
  onPick: (value: string) => void;
}) {
  return (
    <div className="mb-6">
      <h3 className="text-sm font-label font-semibold text-foreground-950 mb-3">{title}</h3>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => (
          <button
            key={opt.value}
            type="button"
            onClick={() => onPick(opt.value)}
            className={`px-3 py-1.5 rounded-md text-xs font-label border transition-colors cursor-pointer whitespace-nowrap ${
              active === opt.value
                ? "bg-primary-700 text-background-50 border-primary-700"
                : "bg-background-50 text-foreground-700 border-background-300 hover:border-primary-300"
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterSidebar({ years, filters, onChange, onReset }: FilterSidebarProps) {
  return (
    <div className="rounded-lg bg-background-50 border border-background-200/70 p-5">
      <div className="flex items-center justify-between mb-5">
        <h2 className="font-heading text-base font-semibold text-foreground-950 flex items-center gap-2">
          <i className="ri-filter-3-line"></i> 筛选
        </h2>
        <button
          type="button"
          onClick={onReset}
          className="text-xs font-label text-primary-600 hover:text-primary-800 transition-colors cursor-pointer"
        >
          重置
        </button>
      </div>
      <Group
        title="类型"
        options={MEDIA_OPTIONS}
        active={filters.media}
        onPick={(v) => onChange({ media: v })}
      />
      <div className="mb-6">
        <h3 className="text-sm font-label font-semibold text-foreground-950 mb-3">年份</h3>
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            onClick={() => onChange({ year: "all" })}
            className={`px-3 py-1.5 rounded-md text-xs font-label border transition-colors cursor-pointer whitespace-nowrap ${
              filters.year === "all"
                ? "bg-primary-700 text-background-50 border-primary-700"
                : "bg-background-50 text-foreground-700 border-background-300 hover:border-primary-300"
            }`}
          >
            全部
          </button>
          {years.map((year) => (
            <button
              key={year}
              type="button"
              onClick={() => onChange({ year: String(year) })}
              className={`px-3 py-1.5 rounded-md text-xs font-label border transition-colors cursor-pointer whitespace-nowrap ${
                filters.year === String(year)
                  ? "bg-primary-700 text-background-50 border-primary-700"
                  : "bg-background-50 text-foreground-700 border-background-300 hover:border-primary-300"
              }`}
            >
              {year}
            </button>
          ))}
        </div>
      </div>
      <Group
        title="评分"
        options={RATING_OPTIONS}
        active={filters.minRating}
        onPick={(v) => onChange({ minRating: v })}
      />
    </div>
  );
}